var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppviewWithNavigationAndTabs',{attrs:{"top":""}},[_c('div',{staticClass:"w-full flex flex-row flex-wrap justify-center md:w-2/3 lg:w-6/12 mx-auto h-full"},[_c('MultiStepRegistration',{staticClass:"w-full my-12"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }